// extracted by css-extract-rspack-plugin
export default {"serve":"TAJlqg0mnY_G1eAO","variation":"gEkPgQn3H0gdoS46"};